export default {
  date: 'August 8, 2025',
  title: 'Automated GLTF Scene Export — Ready in 3, 6, or 12 Hours',
  description: 'Delivering clean architectural geometry and editable assets in GLTF/GLB — optimized for Blender, Unity, Unreal, and more.',
  metaTitle: 'AI 3D Scene Export in GLTF – Ready in 3, 6, or 12 Hours',
  metaDescription: 'Get high-quality 3D scenes in GLTF/GLB format in just hours. Full, optimized, or architectural-only exports. Blender, Unreal, Unity compatible.',
  id: 'automated-GLTF-scene-export',
  jsx: () => (
    <div class='novelty__text'>
      <p>Getfloorplan now offers fast, AI-powered export of 3D scenes in GLTF format, fully compatible with Blender, 3ds Max, Unreal Engine, Unity, and other industry-standard 3D visualization tools.</p>
      <p>Thanks to automation, you can receive architectural base scenes in just 3, 6, or 12 hours, depending on urgency, complexity, and your specific requirements.</p>
      <p>
        <b>Available Scene Formats</b>
      </p>
      <p>Choose the option that fits your workflow:</p>
      <p>
        <b>Full Scene</b>
      </p>
      <p>Includes all furniture and assets. Objects are fully editable — you can move, recolor, or replace them freely. Uses high-poly models, resulting in a heavier file with maximum detail.</p>
      <p>
        <b>Optimized Scene</b>
      </p>
      <p>A lightweight version optimized for faster loading and smoother performance. Ideal for web use, previews, and quick iterations.</p>
      <p>
        <b>Wall Overlays Only</b>
      </p>
      <p>Architectural base only — includes walls, partitions, and openings. Perfect if your team will add furniture or apply custom materials and textures.</p>
      <p>
        <a href='https://drive.google.com/drive/u/0/folders/1nTsOYz5l2HZqr67f2qYSvRBZ8REAMgkr'>GLTF Demo Files</a>
      </p>
      <p>
        <b>Key Benefits</b>
      </p>
      <ul style='margin-left: 50px'>
        <li class='margin-none'>
          Export in fully editable GLTF format (.gltf / .glb)
          <p>Coming in August: Export to FBX format will also be available! Currently in testing — available upon request.</p>
        </li>
        <li class='margin-none'>
          Customization based on your specifications
          <p>We adapt to your internal requirements, software stack, and production pipeline.</p>
        </li>
        <li class='margin-none'>Delivered scenes include core architectural elements (walls, windows, doors), fully ready for further development.</li>
        <li class='margin-none'>We handle the repetitive modeling work, so your 3D team can focus on creative and complex tasks.</li>
        <li class='margin-none'>Save time, reduce costs, and scale faster.</li>
        <li class='margin-none'>Ideal for digital agencies in real estate, PropTech, architectural visualization, and development industries.</li>
      </ul>
      <p>
        <b>How It Works</b>
      </p>
      <ol style='margin-left: 50px'>
        <li class='margin-none' style='margin-bottom: 1rem'>
          <p>You send us your project and technical requirements.</p>
        </li>
        <li class='margin-none' style='margin-bottom: 1rem'>
          <p>We create a test demo, align on key details, and refine based on your feedback.</p>
        </li>
        <li class='margin-none' style='margin-bottom: 1rem'>
          <p>Once approved, we proceed with the full export — based on the agreed demo.</p>
        </li>
        <li class='margin-none' style='margin-bottom: 1rem'>
          <p>Our AI system processes the input and delivers a tailored GLTF scene in 3, 6, or 12 hours, depending on your timeline.</p>
        </li>
      </ol>
      <p>
        <b>Project Volumes & Throughput</b>
      </p>
      <p>On average, we can export 10–30 apartment units per day.</p>
      <p>Higher volumes and faster turnaround are possible after an initial test phase and full alignment on requirements.</p>
      <p>
        <b>Open to Collaboration</b>
      </p>
      <p>We’re actively exploring pilots, partnerships, and integration into production pipelines. If you work in 3D, architectural visualization, or scene generation, we’d love to hear from you.</p>
      <p>Let’s schedule a call and create a proof of concept together.</p>
    </div>
  ),
  thumb: 'news/57.webp',
};
